<div *ngIf="vertrag" id="vertrag" [class.mobil]="plattform == 'mobil'">
  <div
    [innerHTML]="vertrag.infoTextHTML | base64"
  ></div>
  <button
    *ngIf="plattform == 'mobil' && mandant.darstellungRegistrierung == 2"
    (click)="zueruckZurZwischenseite()"
  ><mat-icon>delete</mat-icon><span>Registrierung verwerfen</span></button>
</div>
